import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import FinishLater from '../FinishLater/FinishLater';
import SideNavStepProgressBar from '../../common/SideNavStepProgressBar/SideNavStepProgressBar';
import cloraLogo from '../../../../assets/images/Logo_Gray.svg';
import './OnboardingHeader.scss';

function OnboardingHeader({
  onboardType,
  name,
  finishViewLink,
  claimInfoUrl,
  profileUrl,
  csrfToken,
  step,
  state,
  userId,
  updateMenu,
  handleMenuUpdate,
  handleMenuClick,
  showFinishPage,
}) {
  return (
    <div className="onboarding-header-nav">
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <div className="navbar-header">
            <div className="d-flex">
              { !showFinishPage
              && (
              <button
                className="navbar-toggler me-3"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#clora-onboarding-navbar"
                aria-controls="navbarText"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon" />
              </button>
              )}
              <a className="navbar-brand" href="#">
                <span className="navbar-brand">
                  <img src={cloraLogo} alt="clora logo" className="brand-img" height={30} width={75} />
                </span>
              </a>
            </div>
            { !showFinishPage && step !== 0
            && (
              <FinishLater
                claimInfoUrl={claimInfoUrl}
                userId={userId}
                onboardType={onboardType}
                name={name}
                step={step}
                resourceLink={finishViewLink || '/opportunities'}
                profileUrl={profileUrl}
                csrfToken={csrfToken}
              />
            )}
          </div>
          <div className="collapse navbar-collapse" id="clora-onboarding-navbar">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li>
                <SideNavStepProgressBar
                  step={step}
                  state={state}
                  userId={userId}
                  updateMenu={updateMenu}
                  handleMenuUpdate={handleMenuUpdate}
                  handleMenuClick={handleMenuClick}
                />
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

OnboardingHeader.propTypes = {
  onboardType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  finishViewLink: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  step: PropTypes.number.isRequired,
  state: PropTypes.number.isRequired,
  userId: PropTypes.string.isRequired,
  handleMenuClick: PropTypes.func.isRequired,
  updateMenu: PropTypes.bool.isRequired,
  handleMenuUpdate: PropTypes.func.isRequired,
  claimInfoUrl: PropTypes.func.isRequired,
  profileUrl: PropTypes.string.isRequired,
  showFinishPage: PropTypes.bool.isRequired,
};

export default OnboardingHeader;
